module.exports = __webpack_public_path__ + "img/36_71.0bf876c7.png";